class CommunityReviewsSlider extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.dots = this.querySelectorAll('.slider-dot');
    this.slides = this.querySelectorAll('.slider__slide');
    this.currentSlide = 0;
    
    if (this.dots.length > 0) {
      this.initSlider();
    }
  }

  initSlider() {
    // Add click event listeners to dots
    this.dots.forEach((dot, index) => {
      dot.addEventListener('click', () => {
        this.goToSlide(index);
      });
    });

    // Add scroll event listener to update active dot
    this.slider.addEventListener('scroll', () => {
      this.updateActiveDot();
    });

    // Initialize active dot
    this.updateActiveDot();
  }

  goToSlide(slideIndex) {
    if (slideIndex >= 0 && slideIndex < this.slides.length) {
      const slide = this.slides[slideIndex];
      slide.scrollIntoView({
        behavior: 'smooth',
        block: 'nearest',
        inline: 'start'
      });
      this.currentSlide = slideIndex;
      this.updateActiveDot();
    }
  }

  updateActiveDot() {
    const scrollLeft = this.slider.scrollLeft;
    const slideWidth = this.slider.clientWidth;
    const currentSlideIndex = Math.round(scrollLeft / slideWidth);
    
    // Update active dot
    this.dots.forEach((dot, index) => {
      dot.classList.toggle('slider-dot--active', index === currentSlideIndex);
    });
    
    this.currentSlide = currentSlideIndex;
  }
}

customElements.define('community-review-slider', CommunityReviewsSlider);